export const registrationContactEmail = 'easytools@brunner-anliker.com'
